module.exports = __webpack_public_path__ + "img/no-cultures.82f253be.svg";